
import '@/ioc/index';
import '@/src/shared/utils/yup-extensions';
import '@/src/shared/presentation/styles/reset.css';
import '@/src/shared/presentation/styles/globals.css';
import '@/src/shared/presentation/styles/fonts.css';
import 'react-phone-number-input/style.css';
import Head from 'next/head';
import { appWithTranslation } from 'next-i18next';

import { HreflangProvider } from '@/src/shared/presentation/providers/hreflang-provider';

import type { AppProps } from 'next/app';

// import { AppLoader } from '@/src/shared/presentation/components/app-loader/app-loader';
// import { Modal } from '@/src/shared/presentation/components/modal/modal';

function App({ Component, pageProps }: AppProps) {
  return (
    <HreflangProvider>
      <Head>
        <title>Utopicus</title>
        <meta httpEquiv="referrer" content="no-referrer, strict-origin-when-cross-origin" />
        <meta name="theme-color" content="#43B4E3" />
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
      </Head>
      {/* <Modal />
      <AppLoader /> */}
      <Component {...pageProps} />
    </HreflangProvider>
  );
}

export default appWithTranslation(App);
